import {
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  PopoverVirtualElement,
  Tooltip,
} from '@mui/material';
import {
  IconArrowRight,
  IconCopy,
  IconExternalLink,
  TablerIcon,
} from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';
import { SxProps } from '@mui/system';
import { Theme } from '@mui/material/styles';
import { SyntheticEvent, useState } from 'react';
import { copyClipboard } from 'utils/functions';

type InlineGoToButtonProps = {
  link: string;
  tooltip?: string;
  recordName?: string;
  sx?: SxProps<Theme>;
  Icon?: TablerIcon;
  isExternalLink?: boolean;
};

const InlineGoToButton = ({
  link,
  tooltip = '',
  recordName = 'Record',
  Icon = IconArrowRight,
  isExternalLink = false,
  sx,
}: InlineGoToButtonProps) => {
  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = useState<
    Element | PopoverVirtualElement | null
  >(null);

  const handleClick = (event: SyntheticEvent) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Menu
        id="menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        variant="selectedMenu"
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <MenuItem
          onClick={() => {
            if (isExternalLink) {
              window.open(link);
            } else {
              navigate(link);
            }
            handleClose();
          }}
        >
          <ListItemIcon>
            <IconArrowRight />
          </ListItemIcon>
          <ListItemText>Go To {recordName}</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            if (isExternalLink) {
              window.open(link, '_blank');
            } else {
              window.open(`${window.location.origin}${link}`, '_blank');
            }
            handleClose();
          }}
        >
          <ListItemIcon>
            <IconExternalLink />
          </ListItemIcon>
          <ListItemText>Open {recordName} In New Tab</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            if (isExternalLink) {
              copyClipboard(link);
            } else {
              copyClipboard(`${window.location.origin}${link}`);
            }
            handleClose();
          }}
        >
          <ListItemIcon>
            <IconCopy />
          </ListItemIcon>
          <ListItemText>Copy Link to {recordName}</ListItemText>
        </MenuItem>
      </Menu>
      <Tooltip title={tooltip} sx={{ ...sx }}>
        <IconButton
          onMouseDown={(event) => event.stopPropagation()}
          onTouchStart={(event) => event.stopPropagation()}
          onClick={(event) => {
            event.stopPropagation();
            event.preventDefault();
            handleClick(event);
          }}
          size="small"
        >
          <Icon width={20} height={20} />
        </IconButton>
      </Tooltip>
    </>
  );
};

export default InlineGoToButton;
